import type { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"

export interface Item {
    /**
     * @title Imagem
     */
    image?: ImageWidget

    /**
     * @title Título
     */
    label: string

    /**
     * @title Descrição
     */
    description: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string

    /**
     * @title Itens
     */
    items: Item[]

    /**
     * @title Imagem de fundo
     */
    backgroundImage?: ImageWidget
}

export default function Benefits({ title, items, backgroundImage }: Props) {
    if (!items?.length) return null

    return (
        <div
            className='py-12 bg-fixed lg:bg-scroll'
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className='max-w-[1810px] mx-auto font-lato grid justify-items-center gap-8 lg:gap-12'>
                {title && (
                    <h2 className='text-white text-[45px] text-center font-black resale-lingerie-scale-animation lg:text-[54px]'>
                        {title}
                    </h2>
                )}

                <ul className='w-full flex flex-wrap justify-center gap-x-8 gap-y-12'>
                    {items.map((item) => (
                        <li className='max-w-[240px] grid justify-items-center content-start gap-2 lg:max-w-[210px]'>
                            {item.image && (
                                <Image
                                    className='lg:mb-4 aspect-square object-contain'
                                    src={item.image}
                                    alt={item.label}
                                    width={120}
                                    height={120}
                                    loading='lazy'
                                />
                            )}

                            <h3 className='text-white text-xl text-center font-bold lg:text-lg'>
                                {item.label}
                            </h3>

                            <p className='text-white text-lg text-center leading-7 lg:text-base'>
                                {item.description}
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
